import { useEffect, useState } from 'react';
import { Loader2 } from 'lucide-react';
import { confirmBooking, type ConfirmState } from '../../api/forms';
import ThankYou from './ThankYou';

// Standalone-Ansicht für den Bestätigungs-Link aus der Ferien-Vorbuchungs-Mail
// (?confirm=<token>). Wird statt des Formulars gerendert (siehe main.tsx).
export default function ConfirmBooking({ token }: { token: string }) {
  const [state, setState] = useState<ConfirmState | 'loading' | 'error'>('loading');

  useEffect(() => {
    let active = true;
    confirmBooking(token)
      .then((r) => active && setState(r.state))
      .catch(() => active && setState('error'));
    return () => {
      active = false;
    };
  }, [token]);

  return (
    <div className="rf-root">
      {state === 'loading' && (
        <div className="rf-center"><Loader2 className="animate-spin" /> Dein Termin wird bestätigt …</div>
      )}

      {(state === 'confirmed' || state === 'already') && (
        <ThankYou title="Termin bestätigt!">
          <p>
            {state === 'already'
              ? 'Dein Probetraining war bereits bestätigt – alles klar, wir sehen uns!'
              : 'Danke! Dein Probetraining ist jetzt fest eingeplant. Wir freuen uns auf dich!'}
          </p>
        </ThankYou>
      )}

      {state === 'canceled' && (
        <div className="rf-alert rf-alert--info">
          Dieser Termin ist leider nicht mehr aktiv – die Bestätigungsfrist ist abgelaufen
          oder der Termin wurde storniert. Buche dir gern einfach einen neuen Termin.
        </div>
      )}

      {(state === 'not_found' || state === 'error') && (
        <div className="rf-alert rf-alert--error">
          Der Bestätigungs-Link ist ungültig oder abgelaufen. Bitte buche dir bei Bedarf
          einen neuen Termin oder melde dich kurz bei uns.
        </div>
      )}
    </div>
  );
}
